import { FC } from 'react';

import { AccountInfo } from '@/pages/Account/ui/account-info';

import { useSendAccountStore } from '@/entities/currency-account/model/store';

import { ICurrencyAccount } from '@/shared/lib';

//for the flow when we are on account page or widget on main page
export const AddMoneyRequisites: FC<{ account?: ICurrencyAccount }> = ({
  account,
}) => {
  return account ? <AccountInfo account={account} isModal /> : null;
};

//TODO: for the flow when we choose account from select, props don't work for this
export const AddMoneyRequisitesForSend: FC = () => {
  const accountSet = useSendAccountStore((state) => state.account);

  return accountSet ? <AccountInfo account={accountSet} isModal /> : null;
};
